import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2, Star } from "lucide-react";

const FIELDS = [["label", "Label (Home, Day Program…)"], ["line1", "Street"], ["city", "City"], ["state", "State"], ["zip", "ZIP"], ["lat", "Lat (optional)"], ["lng", "Lng (optional)"]];

export const AddressEditor = ({ value = [], onChange }) => {
  const set = (i, k, v) => onChange(value.map((a, j) => (j === i ? { ...a, [k]: v } : a)));
  const add = () => onChange([...value, { id: crypto.randomUUID(), label: "", state: "OH", is_default: value.length === 0 }]);
  const remove = (i) => onChange(value.filter((_, j) => j !== i));
  const makeDefault = (i) => onChange(value.map((a, j) => ({ ...a, is_default: j === i })));
  return (
    <div className="space-y-3" data-testid="address-editor">
      {value.map((a, i) => (
        <div key={a.id} className="border border-border rounded-md p-3 space-y-2" data-testid="address-row">
          <div className="grid grid-cols-2 gap-2">
            {FIELDS.map(([k, ph]) => (
              <Input key={k} placeholder={ph} value={a[k] ?? ""} className={k === "line1" ? "col-span-2" : ""}
                onChange={(e) => set(i, k, e.target.value)} data-testid={`address-${k}-${i}`} />
            ))}
          </div>
          <div className="flex justify-between">
            <Button type="button" size="sm" variant={a.is_default ? "default" : "ghost"} onClick={() => makeDefault(i)} data-testid={`address-default-${i}`}>
              <Star className="w-3.5 h-3.5 mr-1" /> {a.is_default ? "Default" : "Make default"}
            </Button>
            <Button type="button" size="sm" variant="ghost" className="text-danger" onClick={() => remove(i)} data-testid={`address-remove-${i}`}><Trash2 className="w-4 h-4" /></Button>
          </div>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={add} data-testid="address-add-btn"><Plus className="w-4 h-4 mr-1" /> Add address</Button>
    </div>
  );
};

export const fmtAddress = (a) => (a ? [a.line1, a.city, a.state, a.zip].filter(Boolean).join(", ") : "");
